import React, { useState } from 'react';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48724258783451:1';
  const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48724261339355:1';
  return <section id="oferta" className="bg-violet-gradient py-10 px-5 scroll-mt-10" data-id="element-188">
      <div className="max-w-xl mx-auto" data-id="element-189">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-190">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-50 mb-2" data-id="element-191">
            Elegí tu{' '}
            <span className="text-brand-yellow" data-id="element-192">
              Mega Pack AutoCoaching Emocional™:
            </span>
          </h2>
          <p className="text-sm text-gray-300" data-id="element-193">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        {/* Option 1 - Basic */}
        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-brand-dark/60 backdrop-blur-sm rounded-xl p-5 mb-4 border-2 transition-all ${selected === 'basico' ? 'border-brand-yellow/50' : 'border-gray-800'}`} data-id="element-194">
          <div className="flex items-start justify-between gap-4" data-id="element-195">
            <div className="flex items-start gap-3" data-id="element-196">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-white' : 'border-gray-600'}`} data-id="element-197">
                {selected === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-198" />}
              </div>
              <div data-id="element-199">
                <div className="flex items-center gap-2 mb-1" data-id="element-200">
                  <span className="text-base" data-id="element-201">📘</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-202">
                    MEGA PACK AUTOCOACHING EMOCIONAL™
                  </h4>
                </div>
                <p className="text-xs text-gray-500" data-id="element-203">6 tomos + 6 bonos</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-204">
              <div className="text-xs text-gray-600 line-through" data-id="element-205">
                $27.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-206">$19.990</div>
            </div>
          </div>
        </button>

        {/* Option 2 - Highlighted */}
        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-gray-900 rounded-xl p-5 relative border-2 transition-all ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-800'}`} data-id="element-207">
          <div className="flex items-start justify-between gap-4" data-id="element-208">
            <div className="flex items-start gap-3" data-id="element-209">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-210">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brand-yellow" data-id="element-211" />}
              </div>
              <div data-id="element-212">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-213">
                  <span className="text-base" data-id="element-214">🏆</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-215">
                    MEGA PACK + SISTEMA COACHING LISTO™ ⭐
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-1" data-id="element-216">
                  <span className="bg-brand-yellow text-black text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-217">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-218">
                    AHORRÁS $20.000
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-tight" data-id="element-219">
                  6 tomos + 6 bonos + Sistema completo
                </p>
                <p className="text-[10px] text-gray-500 mt-0.5 leading-tight" data-id="element-220">
                  (Sistema práctico para aplicar en situaciones reales)
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-221">
              <div className="text-xs text-gray-600 line-through" data-id="element-222">
                $49.990 ARS
              </div>
              <div className="text-2xl font-black text-white" data-id="element-223">$27.990 </div>
            </div>
          </div>
        </button>

        {/* CTA Button */}
        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full bg-brand-yellow hover:bg-brand-yellowHover text-black md:text-lg py-4 px-6 rounded-xl shadow-[0_4px_20px_0_rgba(251,191,36,0.4)] transition-all hover:scale-[1.02] text-center mt-8 mb-4 text-[14px] font-[900]" data-id="element-224">
          {'👉 QUIERO EL MEGAPACK + SISTEMA'}
        </a>

        {/* Subtitle */}
        <p className="text-center text-xs text-gray-500 italic mb-6 max-w-sm mx-auto leading-relaxed" data-id="element-225">
          {'La opción más elegida para empezar a gestionarte mejor hoy.'}
        </p>

        {/* Trust badges */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl py-3 px-4" data-id="element-226">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-227">
            <div className="flex items-center gap-1.5" data-id="element-228">
              <Lock size={13} className="text-brand-yellow" data-id="element-229" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-230">
              <Zap size={13} className="text-brand-yellow" data-id="element-231" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-232">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-233" />
              Garantía 7 días
            </div>
          </div>
        </div>
      </div>
    </section>;
}